export default __webpack_public_path__ + "static/media/Mark-2-Blueprints-01.0af761f3.jpg";